import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getAppointments = async () => {
    const res = await api.get("/Clinician/Appointments");

    return res.data;
};

export const useAppointments = () => {
    return useQuery({
        queryKey: ["appointments"],
        queryFn: getAppointments,
        retry: 3,
        staleTime: 1000 * 60,
    });
};

export const getAppointment = async (id) => {
    const res = await api.get(`/Clinician/Appointments/${id}`);

    return res.data;
};

export const useAppointment = (id) => {
    return useQuery({
        queryKey: ["appointment", id],
        queryFn: () => getAppointment(id),
        retry: 3,
        staleTime: Infinity,
    });
};
